<template>
    <div class="container d-flex justify-content-center align-items-center min-vh-100">
        <div class="card shadow p-4" style="width: 350px;">
            <div class="text-center mb-3">
                <img :src="logoUrl" alt="Company Logo" class="img-fluid" style="max-height: 60px;" />
            </div>
            <h3 class="text-center mb-3">Forgot Password</h3>
            <form @submit.prevent="resetPassword">
                <div class="mb-3">
                    <input v-model="email" class="form-control my-2" placeholder="Email Address" required />
                </div>
                <button class="btn btn-primary w-100 mb-2" type="submit" :disabled="loading">
                    <output v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                    Reset Password
                </button>
            </form>
            <div class="text-center">
                <a href="#" class="text-decoration-none" @click.prevent="login">Login</a>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import eventBus from "@/utils/eventBus";

export default {
    data() {
        return {
            logoUrl: process.env.VUE_APP_LOGO_URL,
            email: '',
            loading: false
        };
    },
    methods: {
        async resetPassword() {
            this.loading = true;
            const redirectUrl = `${window.location.origin}/#/set-password`;
            try {
                const response = await api.put('/v1/users/reset-password', {
                    email: this.email,
                    redirectUrl
                });

                if (response.status === 200) {
                    eventBus.emit('show-alert', { message: response.data.message, type: 'success' });
                }

                this.$router.push('/');
            } catch (error) {
                if (error.response.data.message) {
                    eventBus.emit('show-alert', { message: error.response.data.message, type: 'danger' });
                } else {
                    eventBus.emit('show-alert', { message: 'Failed to initiate password reset.', type: 'danger' });
                }
            } finally {
                this.loading = false;
            }
        },
        async login() {
            this.loading = true;
            this.$router.push('/');
        }
    }
};
</script>